import { getGlobalStore } from '../../store/globalStore'

const modalLoginRequestInterceptor = config => {
  const accessToken = getGlobalStore().getState?.()?.modalLogin?.accessToken

  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`
  }
  return config
}

export default modalLoginRequestInterceptor
